export const createInteractionId = (type: string, id: string): string => {
  return `${type}-${id}`;
};
